import router from "../router";
import axios from "axios";
import { checkPermission } from "@/firebase/fcm";

export async function storeAuthData(data, isHomeRedirect = true) {
  await localStorage.setItem("userData", JSON.stringify(data));
  const token = JSON.parse(localStorage.getItem("userData")).token;
  axios.defaults.headers.common["Authorization"] = `Bearer ` + token;
  if (isHomeRedirect) {
    await router.push({ path: "/" });
  }
  await checkPermission();
}
